import { Card } from "primereact/card";
import useApi from "../../../../Utils/BackendClient";
import { useEffect, useRef, useState } from "react";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import { Toast } from "primereact/toast";
import { Message } from "primereact/message";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";

import commonStyle from "../../CommonStyles.module.css";

const MarketPlace = () => {

    const navigate = useNavigate();
    const toast = useRef();

    const { fetchPluginsList } = useApi();
    
    const [loading, setLoading] = useState(true);
    const [plugins, setPlugins] = useState(null);

    useEffect(() => {

        const fetchData = async () => {

            const response = await fetchPluginsList();

            if (response.status !== 200) {
                DisplayErrors(response.error)
            }
            else {
                setPlugins(response.data);
            }

            setLoading(false);
        }

        fetchData();

    }, [fetchPluginsList]);

    return (<>
        <Toast ref={toast} />
        {loading && <div className="grid">
            <Skeleton width="12.5%" height="20%" />
            <Skeleton width="12.5%" height="20%" />
            <Skeleton width="12.5%" height="20%" />
        </div>}
        {!loading && <div className="grid">
            {(plugins === null || plugins?.length === 0) && <Message severity="warn" text="Для даної організації немає доступних плагінів, для підключення зверніться у підтримку" className="mt-3 ml-3" />}
            {(plugins?.length > 0) && plugins.map(plugin =>
                <div className="col-12 md:col-6 lg:col-4 xl:col-2" key={plugin.plugin_name} onClick={() => navigate(`/marketplace/${plugin.plugin_name}`, { state: { pluginName: plugin.plugin_name }})}>
                    <Card>
                        <div className="flex justify-content-center mb-4">
                            <label className="text-lg font-semibold">{plugin.title}</label>
                        </div>
                        <div className="flex justify-content-center mb-4">
                             <div className={commonStyle.productImageWrapper}>
                            <img src={plugin.logo} alt={plugin.plugin_name} className={commonStyle.productImage}/>
                            </div>
                        </div>
                        <div className="text-center mb-3">
                            <label>{plugin.description}</label>
                        </div>
                        <div className="text-center">
                            {plugin.is_enabled ? <Message severity="success" text="Активний" /> : <Message severity="danger" text="Деактивований" />}
                        </div>
                    </Card>
                </div>
            )}
        </div>}
    </>);
}

export default MarketPlace;